export default __webpack_public_path__ + "b5d954833ab4160422f78731ddffc87d.png";